export const SET_PRODUCT_COLLECTION = 'PRODUCT/SET_PRODUCT_COLLECTION';
export const SET_PRODUCT_INVENTORY = 'PRODUCT/SET_PRODUCT_INVENTORY';
